import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Box, Button, Card, CardActionArea, CardContent, Chip, Divider, Grid,
  List, ListItem, ListItemText, Paper, Stack, TextField, Typography,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, MenuItem, Alert,
  Tabs,Tab,
  Icon
} from "@mui/material";
import { deleteMatchSchedule, getTournamentInfo, getTournamentMatches, setMatchSchedule, updateScheduleIndexService } from "services/tournamentServices";
import { color, timeOptions } from "constant/constant";
import { TCInput, TCSelect } from "components/TopCourtComponents/Input/TopCourtInput";
import { IconTrash, IconEdit, IconX, IconPencil, IconRefresh } from "@tabler/icons";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import moment from "moment";
import { endMatchService, startMatchService, submitSetScore, updateEndMatchService, woMatchService } from "services/matchServices";
import MatchPlayer from "./component/matchPlayer";
import MatchGameCard from "./component/matchesCard";
import TournamentLiveCard from "./component/tournamentLiveCard";

import {
  DragDropContext,
  Droppable,
  Draggable
} from "react-beautiful-dnd";
import ScoreWoDialog from "./component/scoreDialog";

function SetSchedule({ tournamentId, categoriesOptions }) {
  const [matches, setMatches] = useState([]);          // [{ _id, ... }]
  const [scheduled, setScheduled] = useState([]);      // [{ _id, matchId, courtId, date, hour, ... }]

  // selection (multi)
  const [formMatchIds, setFormMatchIds] = useState([]);
  const [selectedMatches, setSelectedMatches] = useState([]);

  // form fields
  const [court, setCourt] = useState("");   // {label,value}
  const [date, setDate] = useState("");     // {label,value}
  const [time, setTime] = useState("");     // "HH:mm"

  // options
  const [courtOptions, setCourtOptions] = useState([]);
  const [dateOptions, setDateOptions] = useState([]);
  const [hourOptions, setHourOptions] = useState([]);

  // NEW: category options (pills) & filter state
  const [categoryOptions, setCategoryOptions] = useState([]); // [{label, value}]
  const [selectedCategories, setSelectedCategories] = useState([]); // array of values
  const [selectedCategoriesMatches, setSelectedCategoriesMatches] = useState([]); // array of values
  
  const [filterDate, setFilterDate] = useState(""); // {label,value} or ""
  const [filterHour, setFilterHour] = useState(""); // string or ""
  const [selectedCourts, setSelectedCourts] = useState({});

  const [loading, setLoading] = useState(false);

  // Score/WO modal
  const [scoreModal, setScoreModal] = useState({ open: false, row: null });

  useEffect(() => {
    loadMatches();
    loadTournamentInfo();
  }, []);

  const getItemStyle = (isDragging, draggableStyle) => ( isDragging ? {
      userSelect: 'none',
      padding: 5,
      background: 'white',
      ...draggableStyle,
  } : { ...draggableStyle });

  useEffect(() => {
    // if (categoriesOptions.length > 0) { }
    setCategoryOptions([...categoriesOptions])
    toggleCategoryPill(categoriesOptions[0].value)
  }, [categoriesOptions])

  const byId = useMemo(
    () => Object.fromEntries(matches.map(m => [m._id, m])),
    [matches]
  );

  useEffect(() => {
    setSelectedMatches(formMatchIds.map(id => byId[id]).filter(Boolean));
  }, [formMatchIds, byId]);

  const toggleSelect = (_id) => {
    setFormMatchIds(prev => prev.includes(_id) ? prev.filter(x => x !== _id) : [...prev, _id]);
  };
  const clearSelection = () => setFormMatchIds([]);
  const unselect = (_id) => {
    setFormMatchIds(prev => prev.filter(x => x !== _id));
    setSelectedCourts(prev => {
      const next = { ...prev };
      delete next[_id];
      return next;
    });
  };

  const loadMatches = async () => {
    const { data, error } = await getTournamentMatches({ tournamentId });
    if (error) return console.error(error);
    if (data) {
      setMatches([...data.matches]);
      setScheduled([...(data.scheduledMatches || [])]);
    }
    setLoading(false)
  };

  const loadTournamentInfo = async () => {
    const { data, error } = await getTournamentInfo({ tournamentId });
    if (error) return console.error(error);
    if (data) {
      const courts = (data.courts || []).map(v => ({
        label: `${v.sportCourtTypeId?.name || "Court"} ${v.name}`,
        value: v._id,
      }));
      const dates = (data.dates || []).map(v => ({ label: v, value: v }));
      setCourtOptions(courts);
      setDateOptions(dates);
      setHourOptions(timeOptions || []);
    }
  };

  const addToSchedule = async () => {
    if (!formMatchIds.length || !date || !time) return;
    console.log('here selectedMatch', selectedMatches)
    const { data, error } = await setMatchSchedule({
      tournamentId,
      matches: formMatchIds,
      date: date?.value,
      courtId: selectedCourts,
      court: court?.value,
      hour: time
    });
    if (error) return console.error(error);
    if (data) {
      await loadMatches();
      setCourt(""); setDate(""); setTime(""); setSelectedCourts({}); setCourt("");
      setFormMatchIds([]); setSelectedMatches([]);
    }
  };

  const removeScheduled = async (_id) => {
    const { data, error } = await deleteMatchSchedule({ matchId: _id });
    if (error) return console.error(error);
    if (data) {
      await loadMatches();
      setCourt(""); setDate(""); setTime("");
      setFormMatchIds([]); setSelectedMatches([]);
    }
  };

  const mapPlayerVs = (v) => {
    const sideA = v.playersSideA || v.match?.playersSideA || [];
    const sideB = v.playersSideB || v.match?.playersSideB || [];
    const winner = v.winner || v.match?.winner || ''
    return (
      <div>
        <div alignItems={"center"} style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{
            opacity: (winner && winner == "a") ? 1 : !winner ? 1 : 0.4,
          }}>
            {sideA.map((p, idx) => <div key={`a-${p._id || idx}`}>{p.name}</div>)}
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            {v.matchScores?.filter(s => s.side === "a")
              .map(a => {
              const b = v.matchScores.find(
                  x => x.side === "b" && x.roundNumber === a.roundNumber
              );

              const highlight = b ? a.score > b.score : false; // only highlight if we know A and B

              return (
                      <TCLabel style={{
                          opacity: highlight ? 1 : 0.4,
                      }}>
                      {a.score}
                      </TCLabel>
                  )
              })
            }
          </div>
        </div>
        <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between' }}>
          <div style={{
            opacity: (winner && winner == "b") ? 1 : !winner ? 1 : 0.4,
          }}>
            {sideB.map((p, idx) => <div key={`b-${p._id || idx}`}>{p.name}</div>)}
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            {v.matchScores?.filter(s => s.side === "b")
                .map(b => {
                const a = v.matchScores.find(
                    x => x.side === "a" && x.roundNumber === b.roundNumber
                );


                const highlight = a ? b.score > a.score : false; // only highlight if we know A and B

                return (
                        <TCLabel style={{
                            opacity: highlight ? 1 : 0.4,
                        }}>
                        {b.score}
                        </TCLabel>
                    )
                })
            }
          </div>
        </div>
      </div>
    );
  };

  const updateSelectedMatchCourt = (matchId, courtOption) => {
    setSelectedCourts(prev => ({ ...prev, [matchId]: courtOption }));
  };

  // ---------------- NEW: Filtering logic ----------------
  const filteredList = useMemo(() => {
    // You can flip this to `matches` if you want to filter non-scheduled
    const source = scheduled;

    // Build helper sets for faster lookup
    const catSelected = new Set(selectedCategories); // values from categoryOptions
    const wantCat = selectedCategories.length > 0;
    const wantDate = !!filterDate.value;
    const wantHour = !!filterHour;

    // Some rows store category by id, some by label; normalize checks
    const valueByLabel = new Map(categoryOptions.map(c => [c.label, c.value]));
    const labelByValue = new Map(categoryOptions.map(c => [c.value, c.label]));

    return source.filter(s => {
      // derive category id/label from row
      const rowCatId = s.categoryId || s.category?._id || null;
      const rowCatLabel = s.category || s.categoryName || (rowCatId ? labelByValue.get(rowCatId) : null);

      // console.log('here val info', s, rowCatId, rowCatLabel)
      // category match
      const passCat = !wantCat
        ? true
        : (rowCatId ? catSelected.has(rowCatId) : (rowCatLabel ? catSelected.has(valueByLabel.get(rowCatLabel)) : false));

      // date match
      const passDate = !wantDate ? true : (s.date === (filterDate?.value || filterDate));

      // hour match
      const passHour = !wantHour ? true : (s.hour === (filterHour?.value || filterHour));

      return passCat && passDate && passHour;
    });
  }, [scheduled, selectedCategories, filterDate, filterHour, categoryOptions]);

  const filteredMatchList = useMemo(() => {
    // You can flip this to `matches` if you want to filter non-scheduled
    const source = matches;

    // Build helper sets for faster lookup
    const catSelected = new Set(selectedCategoriesMatches); // values from categoryOptions
    const wantCat = selectedCategoriesMatches.length > 0;
    const wantDate = !!filterDate.value;
    const wantHour = !!filterHour;

    // Some rows store category by id, some by label; normalize checks
    const valueByLabel = new Map(categoryOptions.map(c => [c.label, c.value]));
    const labelByValue = new Map(categoryOptions.map(c => [c.value, c.label]));

    return source.filter(s => {
      // derive category id/label from row
      const rowCatId = s.categoryId || s.category?._id || null;
      const rowCatLabel = s.category || s.categoryName || (rowCatId ? labelByValue.get(rowCatId) : null);

      // console.log('here val info', s, rowCatId, rowCatLabel)
      // category match
      const passCat = !wantCat
        ? true
        : (rowCatId ? catSelected.has(rowCatId) : (rowCatLabel ? catSelected.has(valueByLabel.get(rowCatLabel)) : false));

      // date match
      const passDate = !wantDate ? true : (s.date === (filterDate?.value || filterDate));

      // hour match
      const passHour = !wantHour ? true : (s.hour === (filterHour?.value || filterHour));

      return passCat && passDate && passHour;
    });
  }, [matches, selectedCategoriesMatches, categoryOptions]);

  // const toggleCategoryPill = (val) => {
  //   setSelectedCategories(prev =>
  //     prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]
  //   );
  // };
  const toggleCategoryPill = (val) => {
    console.log('here val info', val)
    setSelectedCategories([val]);    // always exactly one
  };

  const toggleCategoryPillMatches = (val) => {
    console.log('here val info', val)
    setSelectedCategoriesMatches([val]);    // always exactly one
  }

  const listRef = useRef(null);

  // // Small helper to scroll only the matches list
  // const scrollMatches = useCallback((direction = "down", amount = 200) => {
  //   const el = listRef.current;
  //   if (!el) return;
  //   el.scrollBy({ top: direction === "down" ? amount : -amount, behavior: "smooth" });
  // }, []);

  // unique id for a row (scheduled or match)
const rowId = (x) => String(x._id || x.matchId);

// --- robust onDragEnd ---
const handleOnDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination) return;
    if (destination.droppableId !== source.droppableId) return;
    if (destination.index === source.index) return;

    // Block dropping onto locked rows (by filtered index)
    const destItem = filteredList[destination.index];
    if (destItem?.status === "end" || destItem?.status === "live") return;

    // 1) Reorder inside the filtered view only
    const newFiltered = Array.from(filteredList);
    const [moved] = newFiltered.splice(source.index, 1);
    newFiltered.splice(destination.index, 0, moved);

    // 2) Merge back into the full scheduled array:
    //    - find the indices (slots) in `scheduled` that belong to the filtered subset
    const filteredIds = new Set(filteredList.map(rowId));
    const slots = [];
    scheduled.forEach((item, idx) => {
      if (filteredIds.has(rowId(item))) slots.push(idx);
    });

    //    - fill those slots with the new filtered order
    const newScheduled = [...scheduled];
    const newOrderIds = newFiltered.map(rowId);
    const byId = Object.fromEntries(scheduled.map((x) => [rowId(x), x]));

    newOrderIds.forEach((id, i) => {
      newScheduled[slots[i]] = byId[id];
    });

    setScheduled(newScheduled);

    // 3) Persist new order (send only ids in display order if your API expects that)
    updateIndexService(newFiltered);
  };

  const updateIndexService = async (list) => {
    await updateScheduleIndexService({
      body: list.map(v => v._id)
    })
  }

  // ------------------------------------------------------

  return (
    <Box sx={{ p: 2 }}>
      <style>
          {`
          @keyframes spinInfinite {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
          }
          .spin-infinite {
          animation: spinInfinite 1s linear infinite;
          }
          `}
      </style>
      <Grid container spacing={1}>
        {/* LEFT: Matches (click to toggle) */}
        <Grid item xs={12} md={6}>
          <Paper variant="outlined" sx={{ p: 1, height: { xs: 380, md: 520 }, display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Match</Typography>
            <Divider />
            <Stack direction="row" flexWrap="wrap" useFlexGap gap={0.6} sx={{ mt: 1 }}>
              {categoryOptions.map(cat => {
                const selected = selectedCategoriesMatches.includes(cat.value);
                return (
                  <Chip
                    key={cat.value}
                    label={cat.label}
                    size="small"
                    onClick={() => toggleCategoryPillMatches(cat.value)}
                    color={selected ? "primary" : "default"}
                    variant={selected ? "filled" : "outlined"}
                  />
                );
              })}
            </Stack>
            <Box sx={{ mt: 2, overflow: "auto" }}>
              {matches.length === 0 && (
                <ListItem>
                  <ListItemText primary="" secondary="No data." />
                </ListItem>
              )}
              <Grid container spacing={0.6}>
                {filteredMatchList.map((m) => {
                  const active = formMatchIds.includes(m._id);
                  return (
                    <Grid item xs={6} sm={12} md={12} pb={1} key={m._id} onClick={() => {
                      toggleSelect(m._id)
                    }}>
                      <MatchGameCard match={m} active={active} />
                      {/* <Card
                        variant="outlined"
                        sx={{
                          borderWidth: active ? 2 : 1,
                          borderColor: active ? "primary.main" : "divider",
                          bgcolor: active ? "primary.main" : "background.paper",
                          color: active ? "primary.contrastText" : "text.primary",
                          transition: "all .15s ease",
                        }}
                      >
                        <CardActionArea onClick={() => toggleSelect(m._id)}>
                          <CardContent sx={{ p: 1 }}>
                            <TCLabel>{m.name}</TCLabel>
                            <TCLabel subtitle style={{ opacity: 0.8 }}>
                              {m.category}
                            </TCLabel>
                            <Divider sx={{ mt: 0.5, mb: 0.5 }} />
                            <TCLabel>{mapPlayerVs(m)}</TCLabel>
                          </CardContent>
                        </CardActionArea>
                      </Card> */}
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Paper>
        </Grid>

        {/* RIGHT: Scheduled Match */}
        <Grid item xs={12} md={6}>
          <Paper variant="outlined" sx={{ p: 1, height: { xs: 380, md: 520 }, display: "flex", flexDirection: "column" }}>
            <Typography variant="h6" sx={{ mb: 1, textAlign: { md: "left" } }}>
              Settings
            </Typography>
            <Divider />
            <List dense sx={{ mt: 1, overflow: "auto" }}>
              <Grid>
                <Grid container xs={12} spacing={1} mb={1}>
                    <Grid item xs={12} mt={-1} zIndex={2}>
                      <TCLabel>Total {selectedMatches.length}</TCLabel>
                      <TCSelect
                        placeHolder="Court"
                        options={courtOptions}
                        value={court}
                        onChange={(opt) => setCourt(opt)}
                        styles={{
                          /* ensure the portal sits above cards/dialogs */
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TCSelect
                        placeHolder="Date"
                        options={dateOptions}
                        onChange={(e) => setDate(e)}
                        value={date}
                        styles={{
                          /* ensure the portal sits above cards/dialogs */
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} md={6}>
                      <TCInput
                        type="time"
                        value={time}
                        onChange={(e) => setTime(e.currentTarget.value)}
                      />
                  </Grid>
                  </Grid>
              </Grid>
              {/* {scheduled.length === 0 && (
                <ListItem>
                  <ListItemText primary="No schedule yet." secondary="Select matches below and click Update." />
                </ListItem>
              )} */}

              {
                selectedMatches.length > 0 &&
                <Grid container xs={12}>
                  {/* only scroll this */}
                  <Grid
                    item
                    container
                    xs={12}
                    ref={listRef}
                    spacing={1}
                    pt={1}
                    pb={2}
                    sx={{
                      minHeight: 290,         // adjust as needed
                      maxHeight: 290,
                      overflowY: "auto",
                      pr: 1,                  // keep scrollbar off content
                    }}
                  >
                    {
                      selectedMatches.map((m) => {
                        return (
                          <Grid item xs={6} sm={12} md={12} justifyContent={'center'}>
                            <MatchGameCard match={m} />
                          </Grid>
                        )
                      })
                    }
                  </Grid>
                  <Grid mt={2} item xs={12} textAlign={"right"}>
                    <Button onClick={addToSchedule} variant='contained'>Save</Button>
                  </Grid>
                </Grid>
              }

              {/* {scheduled.map((s) => {
                const m = s.match || byId[s.matchId] || s;
                const wo = s.isWO || m?.isWO;
                const isWO = !!wo;

                return (
                  <Grid item xs={12} key={s._id || `${s.matchId}-${s.date}-${s.hour}`} mt={.6}>
                    <Card variant="outlined" sx={{ borderWidth: 1, borderColor: "divider" }}>
                      <CardContent sx={{ p: 1, paddingBottom: '8px !important' }}>
                        <ListItem sx={{ p: 0 }}>
                          <ListItemText
                            primary={
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                                <div style={{ width: '100%' }}>
                                  <TCLabel>{m.name || s.name}</TCLabel>
                                  <TCLabel subtitle style={{ opacity: 0.8 }}>{m.category || s.category}</TCLabel>
                                  <Divider sx={{ mt: 0.5, mb: 0.5 }} />
                                  <TCLabel>{mapPlayerVs(m)}</TCLabel>
                                  <Divider sx={{ mt: 0.5, mb: 0.5 }} />
                                  <TCLabel subtitle>{`${s.date} • ${s.hour}`}</TCLabel>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  <Button size="small" sx={{
                                    minWidth: 0
                                  }} color="error" disabled={!s.allowRemove} onClick={() => removeScheduled(s._id || s.matchId)}>
                                    <IconTrash/>
                                  </Button>
                                </div>
                              </div>
                            }
                          />
                        </ListItem>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })} */}
            </List>
          </Paper>
        </Grid>

        {/* BOTTOM: Form */}
        {/* <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={6} md={4}>
                <TCSelect
                  placeHolder="Date"
                  options={dateOptions}
                  onChange={(e) => setDate(e)}
                  value={date}
                />
              </Grid>
              <Grid item xs={6} md={4}>
                <TCInput
                  type="time"
                  onChange={(e) => setTime(e.currentTarget.value)}
                />
              </Grid>

              {selectedMatches.length > 0 && (
                <Grid item container xs={12} mt={-2} spacing={1}>
                  {selectedMatches.map(m => (
                    <Grid item xs={12} md={6} key={`sel-${m._id}`}>
                      <Card variant="outlined" sx={{ mb: 0.5 }}>
                        <Grid container p={2}>
                          <Grid item xs={8}>
                            <TCLabel>{m.name}</TCLabel>
                            <TCLabel subtitle style={{ opacity: 0.8 }}>{m.category}</TCLabel>
                            <Divider sx={{ mt: 0.5, mb: 0.5 }}/>
                            <TCLabel>{mapPlayerVs(m)}</TCLabel>
                            <Divider sx={{ mt: 0.5, mb: 0.5 }}/>
                            <TCSelect
                              placeHolder="Court"
                              options={courtOptions}
                              value={selectedCourts[m._id] || null}
                              onChange={(opt) => updateSelectedMatchCourt(m._id, opt)}
                            />
                          </Grid>
                          <Grid item xs textAlign="right">
                            <Button sx={{ minWidth: 0 }} size="small" color="error" onClick={() => unselect(m._id)}>
                              <IconTrash/>
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}

              <Grid item xs={12} mt={-1}>
                <Stack direction="row" gap={1}>
                  <Button
                    variant="contained"
                    onClick={addToSchedule}
                    disabled={!selectedMatches.length || !date || !time || selectedMatches.some(v => !selectedCourts[v._id.toString()])}
                  >
                    Update {selectedMatches.length ? `(${selectedMatches.length})` : ""}
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Grid> */}

        {/* ---------------- NEW BLOCK: Filter + List ---------------- */}
        <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Grid>
              <Typography variant="h6" sx={{ mb: 1 }}>Schedule</Typography>
              <div style={{textAlign: 'right'}} onClick={() => { setLoading(true); loadMatches() }}><IconRefresh 
                  className={loading ? 'spin-infinite' : ''}
                  style={{ display: 'inline-block', color: color.blueIndoor_1, cursor: 'pointer' }}
                  size={20}/>
              </div>
            </Grid>
            <Divider sx={{ mb: 1 }} />

            {/* Filter bar */}
            <Stack spacing={1} sx={{ mb: 1 }}>
              {/* Category pills (multi-select) */}
              <Stack direction="row" flexWrap="wrap" useFlexGap gap={0.6}>
                {categoryOptions.length === 0 && (
                  <Chip label="No categories" size="small" variant="outlined" />
                )}
                {categoryOptions.map(cat => {
                  const selected = selectedCategories.includes(cat.value);
                  return (
                    <Chip
                      key={cat.value}
                      label={cat.label}
                      size="small"
                      onClick={() => toggleCategoryPill(cat.value)}
                      color={selected ? "primary" : "default"}
                      variant={selected ? "filled" : "outlined"}
                    />
                  );
                })}
              </Stack>
            </Stack>

            {/* Filtered list */}
            {/* Filtered list */}
            {filteredList.length === 0 ? (
              <TCLabel subtitle>No data.</TCLabel>
            ) : (
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId={'place-image-dnd'}>
                  {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef} style={{ textAlign: 'left' }} >
                        { 
                          filteredList.map((s, index) => {
                            const key = `flt-${s._id || s.matchId}`;
                            const m = s.match || byId[s.matchId] || s;
                            console.log('here matchInfo', s)
                            return (<Draggable key={key} draggableId={`${key}`} isDragDisabled={s.status == "end" || s.status == "live"} index={index}>
                              {(providedDrag, snapshotDrag) => (
                                <div key={`${key}`} 
                                  ref={providedDrag.innerRef}
                                  {...providedDrag.draggableProps}
                                  {...providedDrag.dragHandleProps}
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    setScoreModal({ open: true, row: { ...s, match: m } })
                                  }}
                                  style={{
                                    ...getItemStyle(snapshotDrag.isDragging, providedDrag.draggableProps.style),
                                    display: 'flex', textAlign: 'left', background: 'transparent',
                                    paddingTop: 8
                                  }}>
                                  <TournamentLiveCard data={s} />
                                  <Button size="small" sx={{
                                    minWidth: 0
                                  }} color="error" disabled={!s.allowRemove} onClick={(e) => 
                                      {
                                        e.stopPropagation();
                                        removeScheduled(s._id || s.matchId)
                                      }
                                    }>
                                    <IconTrash/>
                                  </Button>
                                </div>
                              )}
                            </Draggable>
                          )})
                        }
                        {provided.placeholder}
                      </div>
                  )}
                </Droppable>
              </DragDropContext>
              // <Grid container spacing={1} mt={1}>
              //   {filteredList.map((s) => {
              //     const key = `flt-${s._id || s.matchId}`;
              //     const m = s.match || byId[s.matchId] || s;
              //     // const key = `flt-${s._id || s.matchId}`;
              //     // const wo = s.walkover || m?.walkover;
              //     // const isWO = !!wo;
              //     // let dur = moment.duration(moment(m.endMatch).diff(moment(m.startMatch)))
              //     // console.log('here dur', dur.asHours())
              //     // let hr = m.isTournament ? Math.floor(dur.asHours()) : null
              //     // let min = m.isTournament ? dur.minutes() : null
              //     // const matchHours = `${hr}h ${min}m`

              //     return (
              //       <Grid item xs={12} md={12} key={key} onClick={() => {
              //         setScoreModal({ open: true, row: { ...s, match: m } })
              //       }}>
              //         <TournamentLiveCard data={s} />
              //       </Grid>
              //     );
              //   })}
              // </Grid>
            )}

          </Paper>
        </Grid>
      </Grid>

      {/* Score / Walkover Modal */}
      <ScoreWoDialog
        open={scoreModal.open}
        row={scoreModal.row}
        onClose={() => setScoreModal({ open: false, row: null })}
        onSaved={async () => {
          setScoreModal({ open: false, row: null });
          await loadMatches();
        }}
      />
    </Box>
  );
}

export default SetSchedule;